import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 查看/详情按钮 */
const DetailButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

DetailButton.defaultProps = {
  icon: ICON_COLLECTION.VIEW,
  text: '查看',
};

export default DetailButton;
